import { resolveServiceDisplayStyle } from "../enrichment-mobile-preview/preview-icons.constants";
import { legacyCategoryToServiceType } from "../../../mappers/service-display-type.util";

export interface ServiceKindBadge {
  readonly label: string;
  readonly icon: string;
  readonly bg: string;
  readonly fg: string;
  readonly abbr: string;
}

/** Editor pill for a service's `value.kind`, styled from the same table the
 *  customer preview uses so both agree on icon and colour. The label is the
 *  raw wire value, like the kind select options. */
export function serviceKindBadge(
  kind: string | null | undefined,
  iconUrl?: string | null,
): ServiceKindBadge | null {
  if (!kind?.trim()) return null;
  const style = resolveServiceDisplayStyle(
    kind,
    iconUrl,
    legacyCategoryToServiceType(kind),
  );
  return {
    label: kind,
    icon: style.icon,
    bg: style.bgColor,
    fg: style.fgColor,
    abbr: style.abbr,
  };
}
